import { FC, Fragment, PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import { getCurrentEnv, getCurrentLoB } from '../lib/utils/utils';
import '../register-web-components';
import Health100Header from './health100-header/health100-header';

interface Props {
  pageName?: string;
  serviceProps?: string;
  serverSideRendered?: boolean;
  hdvCookie?: string;
  targetComponent?: string;
}

const Header: FC<PropsWithChildren<Props>> = ({
  pageName = 'App Store Feedback',
  serviceProps = 'enable_refresh_token=true&slim_header=true',
  serverSideRendered = '',
  hdvCookie = 'on',
  targetComponent = '',
  children
}): ReactElement => {
  const [headerData, setHeaderData] = useState<any>();
  const [lob, setLob] = useState<string | null>(null);
  const env = getCurrentEnv()?.toLowerCase();

  useEffect(() => {
    setLob(getCurrentLoB());
    setHeaderData({
      pageName,
      serviceProps,
      serverSideRendered,
      hdvCookie,
      targetComponent
    });
  }, []);

  if (lob === 'health100') {
    return (
      <Fragment>
        <Health100Header />
        {children}
      </Fragment>
    );
  }

  if (lob === 'cvs') {
    return (
      <Fragment>
        {process?.env?.NEXT_PUBLIC_APP_ENV !== 'pa11y' && headerData && (
          <div>
            <cvs-header-component
              page-name={headerData.pageName}
              base-url={env === 'local' ? 'https://www-qa2.cvs.com' : location.origin}
              service-props={headerData.serviceProps}
              server-side-rendered={headerData.serverSideRendered}
              hdv-cookie={headerData.hdvCookie}
              target-component={headerData.targetComponent}
            />
            {children}
          </div>
        )}
      </Fragment>
    );
  }

  return <>{children}</>;
};

export default Header;
